module.exports = __webpack_public_path__ + "static/5-d229516d707bdfeb957efc09f791eb49.png";